{
  "product_search": {
    "caption": "Product search results",
    "parent_image": "Parent product image",
    "parent_image_unavailable": "No parent product image available",
    "parent_variant_count": "{count} variants",
    "variant_image": "Variant image",
    "variant_image_unavailable": "No variant image available",
    "headings": {
      "product": "Product",
      "identifier": "ID or SKU"
    },
    "search_error": "Failed to search products. Please try again.",
    "empty_state": {
      "title": "Search for a product",
      "subtitle": "Search by ID, name, description, barcode, variant SKU, or variant options."
    }
  },
  "parent_card": {
    "title": "Parent Product",
    "view_in_platform": "View product in {platform}",
    "product_name": "Product Name",
    "id_slug": "ID (slug)",
    "external_id": "External ID",
    "internal_id": "Internal ID",
    "product_options": "Product Options"
  },
  "variants_card": {
    "title_many": "Variants",
    "title_one": "Variant",
    "sku_label": "SKU",
    "show_raw_data": "Show raw data",
    "hide_raw_data": "Hide raw data"
  },
  "stock_card": {
    "title": "Stock Data",
    "not_tracked": "Stock is not being tracked for this variant.",
    "no_data": "No stock data found for this variant.",
    "headings": {
      "location": "Location",
      "stock_level": "Stock Level",
      "min_stock_level": "Min Stock Level",
      "restock_date": "Re-stock Date",
      "last_updated": "Last Updated"
    }
  },
  "pricing_card": {
    "title": "Price List Data",
    "manually_edit": "Manually edit pricing",
    "no_price_lists": "No price lists found",
    "headings": {
      "price_list": "Price List",
      "quantity": "Quantity",
      "unit_of_measure": "Unit of Measure",
      "price": "Price"
    }
  },
  "stock_locations_upsell": {
    "title": "Looking to set different stock locations for your B2B customers?",
    "description": "With <link>stock locations</link> you can specify which stock locations you want your B2B customers to order stock from.",
    "stock_locations_link": "stock locations",
    "change_plan": "Upgrade today",
    "get_started": "Get started"
  }
}
